import React from 'react';

interface Slide {
  src: string;
  title: string;
}

interface ImagesProps {
  data: Slide[];
  onClick: (index: number) => void;
}

const Images: React.FC<ImagesProps> = ({ data, onClick }) => {
  const handleClick = (index: number) => {
    onClick(index);
  };
  
  return (
    <div className="images-container">
      {data.map((slide, index) => (
        <div onClick={() => handleClick(index)} key={index} className="image">
          <img src={slide.src} alt={slide.title} />
        </div>
      ))}
    </div>
  );
};

export default Images;
